import Vue from "vue";

export default {
  namespaced: true,
  state: {
    designerGenerationQuestionsViewNew: {
      component: 'EditInputs',
      prev: 'designer-generations-questions',
      btnText: 'Добавить вопрос',
      componentClass: 'pt40',
      componentData: {
        send: 'questionsGenerations/QUESTION_GENERATIONS_NEW',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Вопрос',
            rules: {
              required: true
            }
          },
          {
            component: 'InputTextarea',
            name: 'info',
            label: 'Вспомогательная информация',
            rules: {
              required: true
            }
          }
        ]
      }
    },
    designerGenerationQuestionsViewEdit: {
      component: 'EditInputs',
      prev: 'designer-generations-questions',
      btnText: 'Сохранить изменения',
      componentClass: 'pt40',
      componentData: {
        data: 'questionsGenerations/QUESTION_GENERATIONS',
        send: 'questionsGenerations/QUESTION_GENERATIONS_EDIT',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Вопрос',
            rules: {
              required: true
            }
          },
          {
            component: 'InputTextarea',
            name: 'info',
            label: 'Вспомогательная информация',
            rules: {
              required: true
            }
          }
        ]
      }
    },
    designerGenerationQuestionsViewDelete: {
      component: 'EditText',
      prev: 'designer-generations-questions',
      btnText: 'Удалить вопрос',
      componentData: {
        data: 'questionsGenerations/QUESTION_GENERATIONS',
        send: 'questionsGenerations/QUESTION_GENERATIONS_DELETE',
        text: 'Вы действительно хотите удалить этот вопрос из карты?'
      }
    },
  },
  actions: {
    'QUESTIONS_GENERATIONS': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}gen_quest/${params.brand}/${params.m_id}/${params.g_id}`)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTIONS_GENERATIONS_FILTER': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}gen_quest_filter/${params.brand}/${params.m_id}/${params.g_id}`)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_GENERATIONS': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}gen_quest/${params.brand}/${params.m_id}/${params.g_id}/${params.id}`)
        .then(
          res => {
            res.body = res.body[0];
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_GENERATIONS_NEW': async (context, params) => {
      return await Vue.http.post(`${process.env.VUE_APP_API_URL}gen_quest`, params)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_GENERATIONS_EDIT': async (context, params) => {
      params.q_id = params._id;
      delete params._id;
      return await Vue.http.put(`${process.env.VUE_APP_API_URL}gen_quest`, params)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_GENERATIONS_DELETE': async (context, params) => {
      if (params.id === undefined) {
        params.id = params._id;
      }
      return await Vue.http.delete(`${process.env.VUE_APP_API_URL}gen_quest/${params.brand}/${params.m_id}/${params.g_id}/${params.id}`)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_GENERATIONS_ORDER': async (context, params) => {
      return await Vue.http.put(`${process.env.VUE_APP_API_URL}count_gen_quest`, params)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    }
  }
}